import { format, formatDistanceToNow, parseISO } from 'date-fns';

export function formatDateTime(date: string | Date | null): string {
  if (!date) return 'N/A';
  const d = typeof date === 'string' ? parseISO(date) : date;
  return format(d, 'MMM d, yyyy h:mm a');
}

export function formatTimeAgo(date: string | Date | null): string {
  if (!date) return 'N/A';
  const d = typeof date === 'string' ? parseISO(date) : date;
  return formatDistanceToNow(d, { addSuffix: true });
}

export function formatDuration(seconds: number | null): string {
  if (seconds === null || seconds === undefined) return 'N/A';

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (days > 0) {
    return `${days}d ${hours}h`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
}

export function formatUptime(bootTime: string | null): string {
  if (!bootTime) return 'N/A';
  const boot = parseISO(bootTime);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - boot.getTime()) / 1000);
  return formatDuration(seconds);
}

export function formatPercentage(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)}%`;
}

/**
 * Normalizes a portal URL: trims whitespace, prepends https:// if no protocol,
 * and strips trailing slashes. Accepts bare domains like "pp.secureedge.neeve.ai".
 */
export function normalizePortalUrl(raw: string): string {
  let url = raw.trim();
  if (url && !/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  return url.replace(/\/+$/, '');
}
